export enum CashPlusRouteName {
	Intro = "intro",
	OptIn = "opt-in",
	OptOut = "opt-out",
	Overview = "overview",
	NotFound = "notfound",
	CashOut = "cashout"
}

// add new query params if needed here
// TODO: these query Params
export enum QueryParamName {
	FiatId = "fiatId",
	FiatWalletId = "fiatWalletId",
	FiatPid = "fiatPid"
}

// add to collection here if there is a new QueryParamName
// TODO: update these when QueryParamName change
export interface QueryParamsCollection {
	[QueryParamName.FiatId]: string;
	[QueryParamName.FiatWalletId]: string;
	[QueryParamName.FiatPid]: string;
}
